<template>
    <div class="home">
        <main>
            <hero-section />
            <who-are-we />
            <solutions />
            <delivery />
            <customer-service />
            <expert />
            <certif />
            <security />
            <form-component />
        </main>
    </div>
</template>

<script>
import HeroSection from './HeroSection.vue';
import WhoAreWe from './WhoAreWe.vue';
import Solutions from './SolutionsSection.vue';
import Delivery from './DeliverySection.vue';
import CustomerService from './CustomerService.vue';
import Expert from './ExpertSection.vue';
import Certif from './CommitmentsCertif.vue';
import Security from './SecuritySection.vue';
import FormComponent from './FormSection.vue';

export default {
    name: 'HomeComponent',
    components: {
        HeroSection,
        WhoAreWe,
        Solutions,
        Delivery,
        CustomerService,
        Expert,
        Certif,
        Security,
        FormComponent,
    }
}
</script>